import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import { Box } from '@mui/system';
import MeasurementInput from '../MeasurementInput/MeasurementInput.js';
import Notification from '../Notification/Notification.js';
import theme from '../../theme/theme.js';
import '../../theme/lightTheme.js';

const wrapperStyles = {
    color: theme.palette.N10.main,
};
const defaultValidate = (startValue, endValue) => {
    if (startValue !== '' && endValue !== '') {
        const startNumber = parseFloat(startValue);
        const endNumber = parseFloat(endValue);
        if (isNaN(startNumber) || isNaN(endNumber) || startNumber > endNumber) {
            return { error: true, errorText: 'Start cannot be larger than end.' };
        }
        else {
            return { error: false, errorText: '' };
        }
    }
    return { error: false, errorText: '' };
};
const NumberRangeInput = (_a) => {
    var { startValue, endValue, onChangeStart, onChangeEnd, contextUnit, customValidate, containerStyle = {}, showError = true } = _a, rest = __rest(_a, ["startValue", "endValue", "onChangeStart", "onChangeEnd", "contextUnit", "customValidate", "containerStyle", "showError"]);
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState('');
    const validateRangeCallback = useCallback((startValue, endValue) => {
        const validate = customValidate !== null && customValidate !== void 0 ? customValidate : defaultValidate;
        const { error, errorText } = validate(startValue, endValue);
        setError(error);
        setErrorText(errorText);
    }, [customValidate]);
    useEffect(() => {
        validateRangeCallback(startValue, endValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleBlur = () => {
        validateRangeCallback(startValue, endValue);
    };
    return (jsxs(Box, Object.assign({ sx: Object.assign(Object.assign({}, wrapperStyles), containerStyle) }, { children: [jsx(MeasurementInput, Object.assign({ value: startValue }, (onChangeStart && { onChange: onChangeStart }), rest, { contextUnit: contextUnit, sx: { maxWidth: '72px' }, error: error, onBlur: handleBlur })), jsx(Box, Object.assign({ component: "span", sx: { px: 1 } }, { children: "\u2014" })), jsx(MeasurementInput, Object.assign({ value: endValue }, (onChangeEnd && { onChange: onChangeEnd }), rest, { contextUnit: contextUnit !== null && contextUnit !== void 0 ? contextUnit : undefined, sx: { maxWidth: '72px' }, error: error, onBlur: handleBlur })), error && showError && (jsx(Notification, Object.assign({ sx: { width: 'auto' }, type: "error" }, { children: errorText })))] })));
};

export { NumberRangeInput as default, defaultValidate };
//# sourceMappingURL=NumberRangeInput.js.map
